import { type MouseEventHandler } from 'react';
import { hasKey } from 'dibs-ts-utils/exports/hasKey.ts';
import dibsCss from 'dibs-css';

export const TILE_SIZES = {
    smaller: 'smaller',
    small: 'small',
    medium: 'medium',
    large: 'large',
    xLarge: 'xLarge',
    xxLarge: 'xxLarge',
    xxxLarge: 'xxxLarge',
    auto: 'auto',
    autoImageLarge: 'autoImageLarge',
    autoSquare: 'autoSquare',
} as const;

// if change this, please also change /dibs-buyer-product-tile/src/styles/styles.scss
export const TILE_SIZES_PX = {
    smaller: 180,
    small: 290,
    medium: 345,
    large: 405,
    xLarge: 445,
    xxLarge: 525,
    xxxLarge: 600,
} as const;

// if change this, please also change /dibs-buyer-product-tile/src/styles/styles.scss
const TILE_IMAGE_HEIGHTS_PX = {
    smaller: 180,
    small: 160,
    medium: 220,
    large: 280,
    xLarge: 320,
    xxLarge: 400,
} as const;

export type TileSize = (typeof TILE_SIZES)[keyof typeof TILE_SIZES];

export const isCompactTileSize = (size: TileSize): boolean =>
    size === TILE_SIZES.smaller || size === TILE_SIZES.small;

/** Auto sizes have no fixed image height, they fall back to the small tile height. */
export const getTileImageHeightPx = (size: TileSize): number =>
    hasKey(TILE_IMAGE_HEIGHTS_PX, size) ? TILE_IMAGE_HEIGHTS_PX[size] : TILE_IMAGE_HEIGHTS_PX.small;

const imageBackgroundColors = {
    white: dibsCss.bgWhite,
    moonStone: dibsCss.bgMoonstone,
} as const;

export type ImageBackgroundColor = keyof typeof imageBackgroundColors;
export type ImageBackgroundColorValue = (typeof imageBackgroundColors)[ImageBackgroundColor];

export const getBackgroundColor = (
    imageBackgroundColor: ImageBackgroundColor | null | undefined
): ImageBackgroundColorValue | undefined =>
    imageBackgroundColor && hasKey(imageBackgroundColors, imageBackgroundColor)
        ? imageBackgroundColors[imageBackgroundColor]
        : undefined;

export type SrcSet = {
    sizes?: string;
    widths?: number[];
    quality?: number;
};

export const SRC_SET_SIZES_TILE = '(max-width:768px) 50vw, (max-width:1024px) 33vw, 25vw';

export type OnClick = MouseEventHandler<HTMLElement>;

export const PRODUCT_PRICE_TYPES = {
    SALE: 'WEEKLY_SALE',
    NET: 'NET',
    RETAIL: 'RETAIL',
    SOLD: 'SOLD',
    HOLD: 'HOLD',
    UNAVAILABLE: 'UNAVAILABLE',
    PUR: 'PUR',
    SOLD_PRICE: 'SOLD_PRICE',
};

export const TEXT_PRICE_TYPES = new Set<string>([
    PRODUCT_PRICE_TYPES.SOLD,
    PRODUCT_PRICE_TYPES.HOLD,
    PRODUCT_PRICE_TYPES.UNAVAILABLE,
    PRODUCT_PRICE_TYPES.PUR,
]);
